import {Link as RouterLink} from 'react-router-dom'

import Button from '@mui/material/Button'
import LockIcon from '@mui/icons-material/LockOutlined'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import {connect} from '../../../state/hooks/tools'
import {findRecordByAttribute, formatDate} from '../../../lib/data'
import {isEmpty} from '../../../lib/tools'

const PasswordSettings = props => (
  <Stack className='password-settings' component='div'>
    <Typography variant='h6' gutterBottom>Password</Typography>
    <Typography className='caption' variant='body2' gutterBottom>
      Changing your password rewraps the key to your account, so it happens on a page of its own.
    </Typography>
    <Stack
      className='password-access'
      component='div'
      sx={{
        alignItems: {sm: 'center'},
        bgcolor: 'Background',
        flexDirection: {xs: 'column', sm: 'row'},
        justifyContent: 'space-between'
      }}>
      <Stack className='summary' component='div' sx={{flexDirection: 'row'}}>
        <Stack className='icon' component='div' sx={{justifyContent: 'center'}}>
          <LockIcon fontSize='large' />
        </Stack>
        <Stack className='details' component='div'>
          <Typography className='heading' variant='body1'>Password</Typography>
          {
            !isEmpty(props.password) && (
              <Typography className='content' variant='body2'>
                Last changed {formatDate(props.password.updatedAt)}
              </Typography>
            )
          }
        </Stack>
      </Stack>
      <Stack className='controls' component='div' direction='row'>
        <Button component={RouterLink} to='/dashboard/password-management' size='small'>Change</Button>
      </Stack>
    </Stack>
  </Stack>
)

const mapStateToProps = ({passwords, users}) => ({
  password: findRecordByAttribute({records: passwords.passwords, attribute: 'userId', id: users.currentUser?.id})
})

export default connect(mapStateToProps)(PasswordSettings)
